// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/WelcomeMission.jsx

import React from 'react';
import MissionCard from './shared/MissionCard';

const launchPromises = [
  'Configure your organization',
  'Understand your compliance goals',
  'Connect your infrastructure',
  'Build your first compliance baseline',
  'Generate your first executive briefing',
];

export default function WelcomeMission({ onBegin }) {
  return (
    <div className="welcome-mission mission-step-shell">
      <div className="mission-hero-panel">
        <div className="mission-hero-sheen" aria-hidden="true" />
        <p className="mission-launch-eyebrow">Mission Launch</p>
        <h1>Welcome Commander</h1>
        <p className="mission-hero-copy">
          Today we’re going to establish your organization’s Compliance Operations Center and get you
          from sign-up to operational clarity in under 30 minutes.
        </p>
        <div className="mission-hero-actions">
          <button type="button" className="mission-primary-button" onClick={onBegin}>Begin Mission</button>
          <span className="mission-time-pill">Estimated time · 18–25 minutes</span>
        </div>
      </div>

      <MissionCard
        eyebrow="What OASYS will do"
        title="A guided launch, not a setup wizard"
        description="Every step explains why it matters, what OASYS is learning, and what value was created."
        tone="premium"
      >
        <div className="mission-promise-list">
          {launchPromises.map((item) => (
            <div className="mission-promise-item" key={item}>
              <span>✓</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </MissionCard>
    </div>
  );
}
